<template>
  <span v-if="type" class="exists-error">
    Введённый {{ text }} существует в системе. Попробуйте <a @click.prevent="$emit('login')">авторизоваться</a>
  </span>
</template>

<script>
export default {
  name: 'exists-error',

  props: {
    type: {
      type: String,
      required: true,
    },
  },

  computed: {
    text() {
      return {
        tel: 'номер телефона',
        email: 'Email',
      }[this.type];
    },
  },
};
</script>

<style lang="scss">
.exists-error {
  a {
    text-decoration: underline;
  }
}
</style>
